import React from "react";
import { Button } from "react-bootstrap";
import quizBadgeSliderImg from '../../../../../../styles/img/quiz-badge-slider-img.png';
import quizBadgeSliderImg2 from '../../../../../../styles/img/quiz-badge-slider-img-2.png';
import quizBadgeSliderImg3 from '../../../../../../styles/img/quiz-badge-slider-img-3.png';
import quizBadgeSliderImg4 from '../../../../../../styles/img/quiz-badge-slider-img-4.png';
import CircleRoundedGreen from "../../../../../../styles/img/svg/CircleRoundedGreen";
import { UiNextArrow, UiPrevArrow } from "../../../../components/common/UiSliderArrows";
import { UiSlider } from "../../../../components/common/UiSlider";

export const CourceSlider = (props) => {


    const UiQuizzerSliderSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: props.slides,
        slidesToScroll: 1,
        nextArrow: <UiNextArrow />,
        prevArrow: <UiPrevArrow />,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                }
            }]

    };


    return (
        <>
            <div className="sb-quiz-detailed">
                <UiSlider UiSliderSettings={UiQuizzerSliderSettings} >
                    <div className="sb-quiz-detailed__slide">
                        <div className="sb-quiz-slide-inner">
                            <CircleRoundedGreen />
                            <img src={quizBadgeSliderImg} />
                            <p>Learning the basics of Volvo</p>
                            <div className="sb-quiz-card-content-btns-compl">
                                <Button className="sb-primary-btn--38">
                                    <span> Completed</span>
                                    <span>12:34 12/10/22</span>
                                </Button>
                            </div>
                        </div>
                    </div>

                    <div className="sb-quiz-detailed__slide">
                        <div className="sb-quiz-slide-inner">
                            <CircleRoundedGreen />
                            <img src={quizBadgeSliderImg2} />
                            <p>New Volvo 4x4 Range</p>
                            <div className="sb-quiz-card-content-btns-compl">
                                <Button className="sb-primary-btn--38">
                                    <span> Completed</span>
                                    <span>12:34 12/10/22</span>
                                </Button>
                            </div>
                        </div>
                    </div>

                    <div className="sb-quiz-detailed__slide">
                        <div className="sb-quiz-slide-inner">
                            <CircleRoundedGreen />
                            <img src={quizBadgeSliderImg3} />
                            <p>Interior Volvo 4x4</p>
                            <div className="sb-quiz-card-content-btns-compl">
                                <Button className="sb-primary-btn--38">
                                    <span> Completed</span>
                                    <span>12:34 12/10/22</span>
                                </Button>
                            </div>
                        </div>
                    </div>

                    <div className="sb-quiz-detailed__slide sb-quiz-detailed__pending ">
                        <div className="sb-quiz-slide-inner">
                            <img src={quizBadgeSliderImg4} />
                            <p>Finishes Volvo 4x4</p>
                            <div className="sb-quiz-card-content-btns-compl">
                                <Button className="sb-primary-btn--38">
                                    <span> Pending</span>
                                    <span></span>
                                </Button>
                            </div>
                        </div>
                    </div>

                    <div className="sb-quiz-detailed__slide sb-quiz-detailed__pending">
                        <div className="sb-quiz-slide-inner">
                            <img src={quizBadgeSliderImg} />
                            <p>Learning the basics of Volvo</p>
                            <div className="sb-quiz-card-content-btns-compl">
                                <Button className="sb-primary-btn--38">
                                    <span> Pending</span>
                                    <span></span>
                                </Button>
                            </div>
                        </div>
                    </div>
                </UiSlider>

            </div>

        </>
    )
}